import type { NskResponse } from "~/models/Api";
import type { LoginParams } from "~/models/Auth";
import { deleteRequest, postRequest } from "~/utils/api/api_handler";

const paths = {
	create: "/vendors/sessions/vendor_companies",
	destroy: "/vendors/sessions/vendor_companies/logout"
};

export const create = async (params: LoginParams): Promise<NskResponse> =>
	postRequest(paths.create, params);

export const destroy = async (): Promise<NskResponse> =>
	deleteRequest(paths.destroy);
